import type { PermitFiltersOptions } from '@contracts/permitSearch/PermitFiltersOptions';
import { PermitApplicationClient } from '@src/permits/services/PermitApplicationClient';
import { useQuery } from '@tanstack/react-query';

export const useGetPermitFiltersOptions = () => {
  const { data } = useQuery<PermitFiltersOptions>({
    queryKey: ['permit.filters.options'],
    queryFn: () => PermitApplicationClient.getPermitFiltersOptions(),
  });

  return {
    options: data,
  };
};
